import React from "react";
import "../supplierAndManufacturers.scss";
import CompanyTablesBlock from "./CompanyTablesBlock";
import BodyHeader from "./BodyHeader";
import TableBody from "./TableBody";
import { HeadersTabsValues } from "..";
import { NoDataYet } from "./CompanyItem";
import PaginationButtonsBlock from "../../paginationButtonsBlock";

const PageBody = ({
  isView = false,
  data = [],
  pageType = HeadersTabsValues[0],
  headersList = [],
  searchString = '',
  sortOrder = 0,
  pageNumber = 1,
  maxPageNumber,
  onPageButtonClick = () => { },
  onArrowButtonClick = () => { },
  setSortOrder = () => { },
  getMSPAllSupplierManufacturer = () => { },
  setHeadersList = () => { },
  onItemClick = () => { },
  onAddClick = () => { }
}) => {
  return (
    <div>
      {
        pageType.pageId == 1 ?
          <div className="clientData">
            <CompanyTablesBlock
              headersList={headersList}
              getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
              setHeadersList={setHeadersList}
              onItemClick={onItemClick}
              data={data}
              onAddClick={onAddClick}
              searchString={searchString}
              sortOrder={sortOrder}
              setSortOrder={setSortOrder}
            />
          </div> : <div>
            <div className="mt-3">
              <div className="f-500 f-14 line-height-22 f-darkgrey">{`Showing ${data?.TotalSupplier} ${data?.TotalSupplier == 1 ? 'item' : 'items'}`}</div>
              <BodyHeader
                headersList={headersList}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
                getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
                setHeadersList={setHeadersList}
              />
              {
                data?.MSPClientRowData_List?.length > 0 ? <div>
                  <TableBody isView={isView} data={data} dataToMap={data?.MSPClientRowData_List} searchString={searchString} onItemClick={onItemClick} />
                </div> : <NoDataYet text={"No Supplier or Manufacturer yet"} onClick={() => { onAddClick(); }} />
              }
              {
                data?.MSPClientRowData_List?.length > 0 && <PaginationButtonsBlock
                  pageNumber={pageNumber}
                  maxPageNumber={maxPageNumber}
                  onButtonClick={onPageButtonClick}
                  onArrowClick={onArrowButtonClick}
                />
              }
            </div>
          </div>
      }
    </div>
  );
};

export default PageBody;
